<template>
	<page enable-flex>
		<c-scroll-list ref="list" class="flex-grow">
			<template #default="{data, index}">
				<div class="item" :key="index" :data="data" @click="mp.navigateWeb(`/article/${type}/${data.id}`)">
					<h5>{{data.title}}</h5>
					<p>{{data.create_date}}</p>
				</div>
			</template>
		</c-scroll-list>
	</page>
</template>

<script>
	export default {
		props: {
			type: String
		},

		data() {
			return {
			}
		},

		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.$refs.list.load({
					url: '/article/published/list',
					data: {
						article_type: this.type
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.item {
		border-radius: .08rem;
		padding: 0 .32rem;
		margin: .2rem .2rem 0;
		background: #fff;

		h5 {
			border-bottom: .01rem solid #eee;
			padding: .2rem 0;
			line-height: .5rem;
			font-size: .32rem;
		}

		p {
			line-height: .8rem;
			text-align: right;
			color: #999;
		}
	}
</style>